"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var listingItem_1 = require("./listingItem");
var ListingView = function (_a) {
    var _b = _a.linkNewWindow, linkNewWindow = _b === void 0 ? true : _b, props = __rest(_a, ["linkNewWindow"]);
    var data = props.data, selector = props.selector, placeholder = props.placeholder, isAlwaysActive = props.isAlwaysActive, removeFn = props.removeFn, itemLinksTo = props.itemLinksTo;
    return ((0, jsx_runtime_1.jsx)("ul", __assign({ className: "listing-view \n      ".concat(data.length === 0 && !isAlwaysActive ? "listing-view--disabled" : "", "\n      ").concat(isAlwaysActive ? "listing-view--active" : "") }, { children: data.length > 0 ? (data.map(function (e, i) {
            var val = typeof selector == "function" ? (selector(e)) : ((0, jsx_runtime_1.jsx)("p", __assign({ className: "mb-0 d-inline-block" }, { children: e[selector] })));
            return ((0, jsx_runtime_1.jsx)(listingItem_1.ListingItem, { text: val, itemId: i, removeFn: removeFn, href: itemLinksTo, linkNewWindow: linkNewWindow }, "".concat(i)));
        })) : ((0, jsx_runtime_1.jsx)("span", __assign({ className: "".concat(isAlwaysActive ? "listing-view--active-placeholder" : "") }, { children: placeholder }), "placeholder")) })));
};
exports.ListingView = ListingView;
